export const SET_ORDER = 'akommo-search/search/SET_ORDER'

export const PERFORM_SEARCH = 'akommo-search/search/PERFORM_SEARCH'
export const STORE_RESULTS = 'akommo-search/search/STORE_RESULTS'

export const GET_RESULTS_PAGE = 'akommo-search/search/GET_RESULTS_PAGE'

export const LOADING_START = 'akommo-search/search/LOADING_START'
export const LOADING_END = 'akommo-search/search/LOADING_END'

export const TOGGLE_WISHLIST = 'akommo-search/search/TOGGLE_WISHLIST'
export const TOGGLE_WISHLIST_SUCCESS = 'akommo-search/search/TOGGLE_WISHLIST_SUCCESS'

export const LOOKUP_EVENT = 'akommo-search/search/LOOKUP_EVENT'

export const SET_ACTIVE_PROPERTY = 'akommo-search/search/SET_ACTIVE_PROPERTY'

export const FILTER = 'akommo-search/search/FILTER'
export const APPLY_FILTER = 'akommo-search/search/APPLY_FILTER'
export const CANCEL_FILTER = 'akommo-search/search/CANCEL_FILTER'
export const SHOW_FILTER = 'akommo-search/search/SHOW_FILTER'
export const HIDE_FILTER = 'akommo-search/search/HIDE_FILTER'



// WEBPACK FOOTER //
// ./src/redux/modules/search/types.js